import { Box } from "@mui/material";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { logoutUser } from '../../store/thunks/authThunks';
import { useAppDispatch } from '../../store';
import { useNavigate } from "react-router-dom";
export default function Logout({isClosed}: {isClosed: boolean}) {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();


    const handleLogout = async () => {
        try{
            const response = await dispatch(logoutUser()).unwrap();
            if(response.message === "Logout successful"){
                navigate("/login");
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center" , cursor: "pointer"}} onClick={handleLogout}>
              <ExitToAppIcon sx={{ color: "text.primary" , paddingRight: "5px" }} /> <Box component="span" className={`logout-text ${isClosed ? "closed" : ""}`} sx={{ fontSize: "1rem" , fontWeight: "bold" , color: "text.primary" }}>Logout</Box>
        </Box>
    )
}